/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
// import { useEffect } from 'react';
import { connect } from 'react-redux';
import './style.scoped.scss';
import { useParams } from 'react-router-dom';
import ResetForm from '../../components/Account/ResetPassword/ResetForm';
import SuccessUI from '../../components/Account/ResetPassword/Success';
import Confirmation from '../../components/Account/ResetPassword/Confirmation';
import ResetPassword from '../../components/Account/ResetPassword';
import AccountPagesWrapper from '../../components/Account/PageWrapper';
import { useEffect } from 'react';

const ResetPasswordPage = ({ user }) => {
  const { email, token } = useParams();

  const [page, setPage] = useState('index');

  useEffect(() => {
    if (email && token && page !== 'form') {
      setPage('form');
    } else if (user && user.sent === true && page !== 'confirmation') {
      setPage('confirmation');
    }
  }, [email, token, page, user]);


  return (
    <AccountPagesWrapper>
      {/* login card wrapper */}
      <div className="wf-account__card reset">
        {page === 'index' ? (
          <ResetPassword />
        ) : page === 'form' ? (
          <ResetForm token={token} email={email} />
        ) : page === 'confirmation' ? (
          <Confirmation />
        ) : <SuccessUI />}
      </div>
    </AccountPagesWrapper>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
});

export default connect(mapStateToProps)(ResetPasswordPage);
